import client from '@/api/client';

class TrafficControlResource {
    client = client;
    resourceName = 'parameters-generator';

    items (params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/items`,
            params,
        });
    }

    deleteItem (itemId) {
        return this.client.request({
            method: 'delete',
            path: `/upyield/v1/${this.resourceName}/items/${itemId}`,
        });
    }

    deleteItems (ids) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/items/bulk-delete`,
            data: { ids },
        });
    }

    files (params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/files`,
            params,
        });
    }

    deleteFile (fileId) {
        return this.client.request({
            method: 'delete',
            path: `/upyield/v1/${this.resourceName}/files/${fileId}`,
        });
    }
}

export default new TrafficControlResource;
